import type { PropsWithChildren } from 'react';
import { Modal as ReactModal } from 'react-bootstrap';

export type ModalBodyProps = {
  className?: string;
};
export const ModalBody = (props: PropsWithChildren<ModalBodyProps>) => {
  const { className, children } = props;
  // const { purpose, color } = useModalContext();

  return <ReactModal.Body className={className}>{children}</ReactModal.Body>;
};
